import React, { useState, useEffect } from 'react'

import { Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import HTMLWidget from '../../HTMLWidget'
import AttachFilesView from '../../attachfiles/AttachFilesView'
import AttachFilesForm from '../../attachfiles/AttachFilesForm'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import EditButton from '../../../components/buttons/editButton/EditButton'
import { doneLoading, startLoading } from '../../../utils/loading'
import { pdfjs } from 'react-pdf'
import RenderPDFWidget from '../../pdfWidgets/RenderPDFWidget'
import { downloadSubprojectFile } from '../../../redux/actions/subProject'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import {
  delFormProjectAppendix,
  saveFormProjectAppendix,
  updateFormProjectAppendixName,
  updateFormProjectAppendixSeq,
} from '../../../redux/actions/subProjectProposal'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../../redux/actions/sidebar'
import { DEFAULT_ERR_MSG, DELETE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { setAlertMessage } from '../../../utils/messageUtil'
import { useDispatch } from 'react-redux'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

export default function AppendixWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, loadMenu } = props
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  // const [notiMsg, setNotiMsg] = useState()
  const [fromAttachFiles, setFromAttachFiles] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  const dispatch = useDispatch()

  useEffect(() => {
    // setSchema(mockSchema)
    // console.log('props.schema?.fromAttachFiles : ', props.schema?.fromAttachFiles)
    if (props.schema?.fromAttachFiles) {
      handleGetFile(props.schema?.fromAttachFiles)
    }
  }, [props.schema])

  const handleGetFile = async (files) => {
    startLoading()
    // setIsPdfError(false)
    // setIsLoadingPDF(true)
    try {
      let attachfiles = []
      for (let index = 0; index < files.length; index++) {
        const element = files[index]
        const response = await downloadSubprojectFile(element.path)
        //console.log('response : ', response)
        if (response) {
          attachfiles.push({ path: element.path, file: response })
        }
      }
      setFromAttachFiles(attachfiles)
    } catch (e) {
      // setIsPdfError(true)
    }
    // setIsLoadingPDF(false)
    doneLoading()
  }

  const handleUpdate = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsEditErr()
    try {
      const response = await updateFormProjectAppendixName(subProjectId, request)
      if (response) {
        setFormSchema(response)
        setIsEditErr(false)
        setAlertMessage('success', SAVE_SUCCESS_MSG)
      } else {
        setIsEditErr(true)
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (e) {
      console.log('e', e)
      setIsEditErr(true)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleUpload = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsUploadErr()
    try {
      const response = await saveFormProjectAppendix(subProjectId, request)
      if (response) {
        setFormSchema(response)

        if (loadMenu) {
          //await dispatch(getSchemaSidebar(subProjectId))

          await dispatch(getSchemaSubProjectSidebar(subProjectId))
        }
        setIsUploadErr(false)
        setAlertMessage('success', SAVE_SUCCESS_MSG)
      } else {
        setIsUploadErr(true)
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (e) {
      console.log('e', e)
      setIsUploadErr(true)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (file) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError()
    try {
      const response = await delFormProjectAppendix(subProjectId, file.id)
      if (response) {
        setFormSchema(response)
        setIsDeleteError(false)
        setAlertMessage('success', DELETE_SUCCESS_MSG)
      } else {
        setIsDeleteError(true)
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await downloadSubprojectFile(fileObj.path)

    downloadFile(file, fileObj.name)

    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await downloadSubprojectFile(fileObj.path)

    previewFile(file, fileObj.name)
    doneLoading()
  }

  const onUpload = (data) => {
    // console.log('onSubmit data', data)
    const file = data[formSchema.attachFiles.name]
    var formData = new FormData()

    file?.forEach((element) => {
      formData.append('files', element.blobFile)
    })

    formData.append('attachDetail', data.attachDetail)

    handleUpload(formData)
  }

  const onUpdate = (file, newName, detail) => {
    let req = {
      id: file.id,
      name: newName,
      detail: detail,
      numSeq: file.seqNo,
    }
    handleUpdate(req)
  }

  const onDelete = (index) => {
    let datas = [...formSchema.attachFiles.value]
    handleDelete(datas[index])
  }

  const onChangSeqNo = async (data, seqNo) => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await updateFormProjectAppendixSeq(subProjectId, data.id, seqNo)
      if (response) {
        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (e) {
      console.log('e', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {formSchema.detail && <Row style={{ marginBottom: 20 }}>{formSchema.detail}</Row>}

      <div
        style={{
          width: 'auto',
          height: 'auto',
          maxHeight: 600,
          overflowY: 'auto',
          overflowX: 'hidden',
          textAlign: 'center',
        }}
      >
        {fromAttachFiles?.map((e) => {
          if (e.path?.endsWith('.pdf') || e.path?.endsWith('.PDF')) {
            return (
              // <div style={{ marginLeft: 30, marginRight: 30, textAlign: 'center' }}>
              <RenderPDFWidget file={e.file} />
              // </div>
            )
          } else {
            let url = window.URL.createObjectURL(new Blob([e.file], { type: e.file.type }))
            return (
              <div
                style={{ marginBottom: 20, marginLeft: 30, marginRight: 30, textAlign: 'center' }}
              >
                <img src={url} style={{ width: '90%', height: 'auto' }}></img>
              </div>
            )
          }
        })}
      </div>

      {isEdit && showCommandButton ? (
        <AttachFilesForm
          schema={formSchema.attachFiles}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          onSubmit={handleSubmit(onUpload)}
          onDelete={onDelete}
          onUpdate={onUpdate}
          onDownload={onDownload}
          onPreview={onPreview}
          onChangSeqNo={onChangSeqNo}
          isChangSeqNo={true}
          isEditErr={isEditErr}
          isUploadErr={isUploadErr}
          isDeleteError={isDeleteError}
          loading={isLoading}
          buttonText={formSchema.buttonText}
          buttonTextAlign="right"
        />
      ) : (
        <AttachFilesView
          schema={formSchema.attachFiles}
          onDownload={onDownload}
          onPreview={onPreview}
        />
      )}

      {formSchema.note && (
        <Message showIcon type="info" description={<HTMLWidget data={formSchema.note} />} />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {/* {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )} */}

          {isEdit ? (
            <div>
              <ViewButton
                icon="backward"
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                  setIsEditErr(false)
                  setIsDeleteError(false)
                  setIsUploadErr(false)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                disabled={isLoading}
              >
                {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
              </ViewButton>
            </div>
          ) : (
            <EditButton
              onClick={() => {
                onChangeIsEdit(!isEdit)
                setIsEditErr(false)
                setIsDeleteError(false)
                setIsUploadErr(false)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              disabled={isLoading}
            >
              {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </EditButton>
          )}
        </div>
      )}
    </Panel>
  )
}
